import { TabReview } from 'components/user/user-detail/tab-review/TabReview'
import { INITIAL_DATA_FILTER } from 'configs/user/user-detail/configTableReview'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_USER } from 'services/apiUser'
import { getAllQueryParams, setQueryParams } from 'utils/utils'
import { useLocation, useSearchParams } from 'react-router-dom'

export const TabReviewContainer = ({ id }) => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = getAllQueryParams(searchParams)
    const [showReview, setShowReview] = useState(false)
    const [detailReview, setDetailReview] = useState('')
    const {
        fetching: getReviewListApi,
        data: reviewList,
        isLoading,
    } = useFetch({ ...API_USER.REVIEW_LIST, initPathVariable: id }, INITIAL_DATA_FILTER)

    useEffect(() => {
        const { tabName, userId, ...queryParams } = query
        getReviewListApi({ ...queryParams })
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const showReviewHandler = (value) => {
        setShowReview(true)
        setDetailReview(value)
    }

    const onHideReview = () => {
        setShowReview(false)
    }

    const props = {
        dataList: reviewList?.data,
        query,
        onChangeQuery,
        showReview,
        onHideReview,
        detailReview,
        showReviewHandler,
        isLoading,
    }

    return <TabReview {...props} />
}
